import type {JSONSchema7} from 'json-schema';

const probeSchema: JSONSchema7 = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    label: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
    disabled: {
      type: 'boolean',
    },
    processors: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: {
            type: 'string',
            minLength: 1,
          },
          type: {
            type: 'string',
            minLength: 1,
          },
          properties: {
            type: 'object',
            additionalProperties: {},
          },
          inputs: {
            type: 'object',
            additionalProperties: {
              type: 'object',
              properties: {
                column: {
                  anyOf: [
                    {type: 'string', minLength: 1},
                    {type: 'null'},
                  ]
                },
                stage: {
                  anyOf: [
                    {type: 'string', minLength: 1},
                    {type: 'null'},
                  ]
                },
              },
              additionalProperties: false,
            }
          },
          outputs: {
            type: 'object',
            additionalProperties: {
              type: 'string',
            },
          }
        },
        required: [
          'type',
          'name',
        ],
        additionalProperties: false,
      },
      minItems: 1,
    },
    stages: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          name: {
            type: 'string',
            minLength: 1,
          },
          description: {
            type: 'string',
          },
          enable_metric_logging: {
            type: 'boolean'
          },
          retention_duration: {
            type: 'number'
          },
          units: {
            type: 'object',
            additionalProperties: {
              type: 'string',
            },
          },
          // left for backward compatibility for older exports, not used anymore
          tags: {
            type: 'array',
            items: {
              type: 'string'
            },
          },
        },
        required: [
          'name',
        ],
        additionalProperties: false,
      },
    },
    // left for backward compatibility for older exports, not used anymore
    tags: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: [
    'label',
    'processors',
  ],
  additionalProperties: false,
};

export default probeSchema;
